import { useEffect, useRef, useState } from "react";
import MasterService from "services/Master.Service";
import PersonalDetailsServices from "../../services/PersonalDetails.Services";
import { IUserModel } from "../../models/User.Model";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { unique } from "underscore";
import { HelperConstant } from "../../helpers/HelperConstant";
import { CustomDropdown } from "components/shared/CustomDropdown";
import GetDofyGeoListServices from "services/GetDofyGeoList.Services";
import { Card, CardBody, Col, Container, Form, Modal, ModalBody, Row } from "reactstrap";
import { CustomTextBox } from "components/shared/CustomTextBox";
import { CustomTextArea } from "components/shared/CustomTextArea";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CustomPhoneNumberBox } from "components/shared/CustomPhoneNumberBox";
import { CustomEmailBox } from "components/shared/CustomEmailBox";
import CommonService from "services/CommonService";
import { CustomButton } from "components/shared/CustomButton";
import { aes_encryption, encryptOrderId } from "../../helpers/Helper";
import { isAdmin, isRider, isSuperAdmin } from "../../helpers/TokenHelper";
import Loader from "components/Common/Loader";
import { CustomToaster } from "components/shared/CustomToaster";

type param = {
    id: any,
    setEditModal: any,
    userId?: any
}

function INDCreateEdit({ id, setEditModal, userId }: param) {
    const [user, setUser] = useState<IUserModel>({} as IUserModel);
    const [dofyGeoList, setDofyGeoList] = useState<Array<any>>([]);
    const [getState, setGetState] = useState<any>([]);
    const [addressData, setAddressData] = useState({ cityId: 0, pincode: "", pinLocation: "" });
    const [getRole, setGetRole] = useState<any>([]);
    const [ProfileImageFile, setProfileImageFile] = useState<any>();
    const [profileImage, setProfileImage] = useState<any>();
    const [showEdit, setShowEdit] = useState(true);
    const [District, setDistrict] = useState<Array<any>>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filterLocation, setFilterLocationList] = useState<Array<any>>([]);
    const [groupedLocation, setGroupedLocationList] = useState<Array<any>>([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isUpload, setIsUpload] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [roleId, setRoleId] = useState(0);
    const [loading, setLoading] = useState(true);

    const [resMeg, setResMeg] = useState('')
    const [showToastUpdate, setShowToastUpdate] = useState(false);

    // const isAddMode = !id;
    const [isAddMode, setIsAddMode] = useState(!id)

    const windowTop = useRef(null) as any;

    const riderlogin: boolean = isRider() ?? false;

    const [photostype] = useState({
        ProfileImage: "ProfileImage.png",
    });

    const encryptedId = aes_encryption(userId);

    const isFromProfile = window.location.pathname.includes("profile");

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            Id: 0,
            Active: true,
            ModifiedBy: 0,
            ValidationErrors: [],
            LoginId: 0,
            UserRoleId: 0,
            UserRoleName: undefined,
            FirstName: "",
            MiddleName: "",
            LastName: "",
            AliasName: "",
            Email: "",
            Prefix: "",
            Suffix: "",
            DateOfBirth: '',
            UploadImagePath: "",
            UploadImageName: "",
            RowOrder: 0,
            Mobile: '',
            SecondaryMobile: '',
            UserLogin: {
                Id: 0,
                Active: true,
                ValidationErrors: {},
                CompanyId: '',
                UserName: '',
                PassWord: undefined,
                Salt: undefined,
                IVKey: undefined,
                ConfirmPassword: undefined,
                RowOrder: '',
            },
            Address: '',
            CityId: '',
            PinCode: '',
            StateId: 0,
            RoleId: 0,
            LocationId: '',
            LocationPin: '',
            Salt: undefined,
            IVKey: undefined
        },
        validationSchema: Yup.object({
            FirstName: Yup.string().required("Please Enter First Name").nullable(),
            LastName: Yup.string().required("Please Enter Last Name").nullable(),
            // AliasName: (roleId == HelperConstant.Roles.Rider) && Yup.string().required("Please Enter Alias Name").nullable(),
            Mobile: Yup.string().required("Please Enter Phone Number").matches(HelperConstant.phonenumberPattern.pattern, "Please Enter valid phone number").nullable(),
            Email: Yup.string().required("Please Enter Email").matches(HelperConstant.emailPattern.pattern, 'Please Enter a Valid Email').nullable(),
            RoleId: Yup.string().notOneOf(['0'], 'Please select a Role').required("Please Select a Role").nullable(),
            StateId: Yup.string().notOneOf(['0'], 'Please select a State').required("Please Select a State").nullable(),
            LocationId: Yup.string().notOneOf(['0'], 'Please select a City').required("Please Select a City").nullable(),
            Address: Yup.string().required("Please Enter Address").nullable(),
        }),

        onSubmit: (values, { setErrors }) => {
            return isAddMode ? createUser(values) : updateUser(values);
        },
    })

    useEffect(() => {
        if (formik.isSubmitting && Object.keys(formik.errors).length > 0) {
            const firstErrorField = Object.keys(formik.errors)[0];
            const errorElement = document.getElementsByName(firstErrorField)[0];

            if (errorElement) {
                errorElement.focus();
                errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }, [formik.isSubmitting, formik.errors]);

    const executeScroll = () => windowTop?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });


    function createUser(data: any) {
        setIsDisabled(true);
        data.Prefix = "";
        data.Suffix = "";
        data.CityId = data.LocationId;
        data.PinCode = filterLocation.find(x => x.Id == data.LocationId)?.Code;
        data.LocationPin = filterLocation.find(x => x.Id == data.LocationId)?.Code;

        let formData = new FormData();
        formData.append("FirstName", data.FirstName);
        formData.append("CityId", data.LocationId);
        formData.append("LocationId", data.LocationId);
        formData.append("LastName", data.LastName);
        formData.append("UserRoleName", data.UserRoleName);
        formData.append("AliasName", data.AliasName);
        formData.append("Mobile", data.Mobile);
        formData.append("Email", data.Email);
        formData.append("Address", data.Address);
        formData.append("StateId", data.StateId);
        formData.append("PinCode", addressData.pincode);
        formData.append("RoleId", data.RoleId);
        formData.append("UserLogin.UserName", data.Mobile);
        formData.append("UserLogin.ConfirmPassword", data.ConfirmPassword);
        formData.append("UserLogin.IVKey", data.IVKey);
        formData.append("UserLogin.PassWord", data.PassWord);
        formData.append("UserLogin.Salt", data.Salt);
        formData.append("UploadFiles", ProfileImageFile);
        formData.append("UploadImageName", photostype.ProfileImage);

        CommonService.postWithFormData('personModel', 'CreateUser', formData).then((res) => {
            if (res.status === 200) {
                if (res.data === "Already registered user" || res.data === "Already registered Mobile Number and Email" || res.data === "Already registered Email") {
                    setShowToastUpdate(true)
                    setResMeg(res.data)
                    setIsDisabled(false);
                }
                else {
                    setResMeg("Created successfully")
                    window.location.href = "/user-dashboard";
                }
            }
        }).catch(e => {
            console.log(e);
        });
    }

    function updateUser(users: any) {
        setIsDisabled(true);

        users.Prefix = "";
        users.Suffix = "";
        users.UploadImageName = "";
        users.UploadImagePath = "";
        users.UserLogin.ConfirmPassword = user.UserLogin.PassWord;
        users.CityId = users.LocationId;
        users.PinCode = filterLocation.find(x => x.Id == users.LocationId)?.Code;
        users.LocationPin = filterLocation.find(x => x.Id == users.LocationId)?.Code;
        // users.CityId = addressData.cityId ? addressData.cityId : user.LocationId;
        // users.PinCode = addressData.pincode ? addressData.pincode : user.PinCode;
        // users.LocationPin = addressData.pinLocation ? addressData.pinLocation : user.LocationPin;
        // users.LocationId = addressData.cityId ? addressData.cityId : user.CityId;
        users.UserLogin.UserName = users.Mobile;
        users.UserLogin.Id = users.LoginId;

        let formData = new FormData();
        formData.append("FirstName", users.FirstName);
        formData.append("LastName", users.LastName);
        formData.append("UserRoleName", users.UserRoleName);
        formData.append("AliasName", users.AliasName);
        formData.append("LoginId", users.LoginId);
        formData.append("Id", users.Id);
        formData.append("UserRoleId", users.UserRoleId);
        formData.append("UserLogin.Id", users.UserLogin.Id);
        formData.append("Mobile", users.Mobile);
        formData.append("Email", users.Email);
        formData.append("Address", users.Address);
        formData.append("StateId", users.StateId);
        formData.append("PinCode", users.PinCode);
        formData.append("CityId", users.CityId);
        formData.append("LocationId", users.LocationId ? users.LocationId : user.LocationId);
        formData.append("RoleId", users.RoleId);
        formData.append("UserLogin.UserName", users.Mobile);
        formData.append("UserLogin.ConfirmPassword", users.UserLogin.ConfirmPassword);
        formData.append("UserLogin.IVKey", users.UserLogin.IVKey);
        formData.append("UserLogin.PassWord", users.UserLogin.PassWord);
        formData.append("UserLogin.Salt", users.UserLogin.Salt);
        formData.append("UploadFiles", ProfileImageFile);
        formData.append("UploadImageName", photostype.ProfileImage);
        formData.append("Active", users.Active);

        CommonService.postWithFormData('personModel', 'EditUser', formData).then((res) => {
            if (res.status === 200) {
                if (res.data === "Already registered user" || res.data === "Already registered Mobile Number and Email" || res.data === "Already registered Email") {
                    setShowToastUpdate(true)
                    setResMeg(res.data)
                    setIsDisabled(false);
                    //window.location.href = "/user-dashboard";
                }
                else {
                    setResMeg("Edited successfully");
                    setEditModal(0);
                }
            }
        }).catch(e => console.log(e))
    }

    const GetRoles = () => {
        MasterService.GetRoles().then(res => {
            if (res.status === 200) {
                setGetRole(res.data)
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const GetStates = (serviceTypeId: number) => {
        MasterService.GetStateList(serviceTypeId).then(res => {
            if (res.status === 200) {
                setGetState(res.data)
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const getCityList = () => {
        MasterService.GetDistrictList(HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setDistrict(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const takePicture = async (photostypes: string) => {
        photostype.ProfileImage = "ProfileImage.png"
        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.DataUrl,
            source: CameraSource.Camera
        });
        const imageFile = dataURLtoFile(image.dataUrl, photostype.ProfileImage);
        const UploadFiles: any = image.dataUrl;
        setProfileImage(UploadFiles);
        setProfileImageFile(imageFile);
        setIsUpload(true);
        formik.setFieldValue("UploadImageName", photostype.ProfileImage);
        formik.setFieldValue("UploadImagePath", imageFile);
    }

    const dataURLtoFile = (dataurl: any, filename: string) => {
        let arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };

    const deleteProfileImage = () => {
        setProfileImage('');
        formik.setFieldValue("UploadImageName", "");
        formik.setFieldValue("UploadImagePath", "");
    }

    const DeleteProfileImage = (personId: any) => {
        PersonalDetailsServices.DeleteProfileImage(personId).then((res: any) => {
            if (res.status == 200) {
                setIsOpenDeleteModal(false);
                setProfileImage('');
                photostype.ProfileImage = '';
                formik.setFieldValue("UploadImageName", '');
                formik.setFieldValue("UploadImagePath", '');
                GetUserDetail(userId ? userId : "0");
            }
        }).catch(e => console.log(e))
    }

    const selectedCityHandler = (value: any) => {
        var stateIdentifier = getState?.find((x: { Id: any; }) => x.Id == value)?.Identifier;
        const validLocation = value ? dofyGeoList.filter(it => it.Parent1 === stateIdentifier) : dofyGeoList;
        setGroupedLocationList(validLocation);
        var uniqueOptions = unique(validLocation, "Name");
        setFilterLocationList(uniqueOptions);
        setIsLoading(false);
    }

    const initialCityHandler = (value: any, data: Array<any>) => {
        const validLocation = value ? data.filter(it => it.Parent1 === value) : data;
        setGroupedLocationList(validLocation);
        var uniqueOptions = unique(validLocation, "Name");
        setFilterLocationList(uniqueOptions);
        setIsLoading(false);
    }
    const GetUserDetail = (id: number) => {
        PersonalDetailsServices.getUser(id).then(res => {
            if (res.status === 200) {
                setUser(res.data);
                GetDofyGeoList(HelperConstant.serviceTypeId.SELL, res.data.LocationId, res.data);
                formik.setValues(res.data);
            }
            if (isAddMode) {
                setLoading(false);
            }
        }).catch(e => {
            console.log(e);
        });
    }
    const GetDofyGeoList = (serviceTypeId: number, LocationId?: any, response?: any) => {
        GetDofyGeoListServices.GetAllDofyGeo(serviceTypeId).then(res => {
            if (res.status === 200) {
                setDofyGeoList(res.data);
                initialCityHandler(response?.Identifier, res.data);
            }
            setLoading(false);
        }).catch(e => {
            console.log(e);
        });
    }

    const GetUserProfile = () => {
        PersonalDetailsServices.GetBase64ProfileImage(userId).then((res) => {
            if (res.status === 200) {
                if (res.data) {
                    var base64ImageString: any = `data:image/png;base64,${res.data}`;
                    setProfileImage(base64ImageString);
                    setShowEdit(true);
                }
            }
        }).catch(e => console.log(e));
    }

    useEffect(() => {
        getCityList();

        if (isAddMode) {
            GetDofyGeoList(HelperConstant.serviceTypeId.SELL);
        }

        GetStates(HelperConstant.serviceTypeId.SELL);
        GetUserDetail(userId ? userId : id);
        GetRoles();

    }, [id, isAddMode]);

    useEffect(() => {
        GetUserProfile();
    }, []);

    if (loading) {
        return <div style={{ display: "flex", justifyContent: "center" }}>
            <Loader />
        </div>
    }

    return (
        <Container fluid className="p-0">
            <Row>
                <Col xl={12}>
                    <Form onSubmit={(e) => {
                        e.preventDefault();
                        formik.handleSubmit();
                        return false;
                    }}>
                        <Card className="p-2">
                            <Row >
                                <Col xl={12} className='text-center'>
                                    <div>
                                        {profileImage ?
                                            <>
                                                <img className="profile-image" src={profileImage} alt="" />
                                                {isUpload ? <div className='mt-2 d-flex justify-content-center'>
                                                    <span className='m-0 text-dofy me-3 fw-semibold'>User Image</span >
                                                    {showEdit ?
                                                        <i className='bx bx-x text-dofy cursor-pointer align-middle font-size-16' slot="end" onClick={() => deleteProfileImage()} />
                                                        : null}
                                                </div> : <div className='d-flex justify-content-center mt-2'>
                                                    <CustomButton type={'button'} btnClassName={`btn-light dofy-admin-font-md fw-semibold btn-sm cursor-pointer`} iconClasssName={'bx bx-trash-alt me-1 align-middle'} name={'Delete'} onClick={() => setIsOpenDeleteModal(true)} />
                                                </div>}

                                            </>
                                            :
                                            <Card className='cursor-pointer' ref={windowTop} onClick={() => { takePicture(photostype.ProfileImage); }} >
                                                <CardBody className="text-center my-4">
                                                    <i className='bx bx-cloud-upload text-dofy font-size-24 cursor-pointer'></i>
                                                    <p className='m-0 mt-2 font-size-14 text-dofy fw-semibold'>Upload Image</p>
                                                </CardBody>
                                            </Card>}
                                    </div>
                                </Col>
                                <Col xl={4}>
                                    <CustomTextBox
                                        name="FirstName"
                                        label="First Name"
                                        id={"FIrstName"}
                                        value={formik.values.FirstName}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.FirstName && formik.errors.FirstName ? true : false}
                                        error={formik.errors.FirstName}
                                        onChange={formik.handleChange}
                                        // placeholder={""}
                                        isMandatory={true} />

                                </Col>
                                <Col xl={4}>
                                    <CustomTextBox
                                        name="LastName"
                                        label="Last Name"
                                        id={"LastName"}
                                        value={formik.values.LastName}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.LastName && formik.errors.LastName ? true : false}
                                        error={formik.errors.LastName}
                                        onChange={formik.handleChange}
                                        // placeholder={""}
                                        isMandatory={true} />
                                </Col>
                                <Col xl={4}>
                                    <CustomTextBox
                                        name="AliasName"
                                        label="Alias Name"
                                        id={"AliasName"}
                                        value={formik.values.AliasName == "null" ? '' : formik.values.AliasName}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.AliasName && formik.errors.AliasName ? true : false}
                                        error={formik.errors.AliasName}
                                        onChange={formik.handleChange}
                                    // placeholder={""}
                                    // isMandatory={true} 
                                    />
                                </Col>
                            </Row>
                            <Row>

                                <Col xl={6}>
                                    <CustomPhoneNumberBox
                                        name="Mobile"
                                        label="Phone Number"
                                        id={"Mobile"}
                                        value={formik.values.Mobile}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.Mobile && formik.errors.Mobile ? true : false}
                                        error={formik.errors.Mobile}
                                        onChange={formik.handleChange}
                                        placeholder={"+91 9087654321"}
                                        isMandatory={true} />
                                </Col>
                                <Col xl={6}>
                                    <CustomPhoneNumberBox
                                        name="SecondaryMobile"
                                        label="Alternative Phone Number"
                                        id={"SecondaryMobile"}
                                        value={formik.values.SecondaryMobile}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.SecondaryMobile && formik.errors.SecondaryMobile ? true : false}
                                        error={formik.errors.SecondaryMobile}
                                        onChange={formik.handleChange}
                                        placeholder={"+91 9087654321"}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xl={6}>
                                    <CustomEmailBox
                                        name="Email"
                                        label="Email"
                                        id={"Email"}
                                        value={formik.values.Email}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.Email && formik.errors.Email ? true : false}
                                        error={formik.errors.Email}
                                        onChange={formik.handleChange}
                                        // placeholder={""}
                                        isMandatory={true} />
                                </Col>
                                <Col xl={6}>
                                    <CustomDropdown
                                        label={"Role"}
                                        id={"RoleId"}
                                        name={"RoleId"}
                                        value={formik.values.RoleId}
                                        data={getRole}
                                        displayField="Name"
                                        valueField="Id"
                                        touched={formik.touched.RoleId}
                                        error={formik.errors.RoleId}
                                        onChange={(e: any) => { formik.handleChange(e); setRoleId(e.target.value) }}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.RoleId && formik.errors.RoleId ? true : false}
                                        isMandatory={true}
                                        disabled={!(isAdmin() || isSuperAdmin())} />
                                </Col>

                            </Row>
                            <Row>
                                <Col xl={6}>
                                    <CustomDropdown
                                        label={"State"}
                                        id={"StateId"}
                                        value={formik.values.StateId}
                                        data={getState}
                                        displayField="Name"
                                        valueField="Id"
                                        name={"StateId"}
                                        touched={formik.touched.StateId}
                                        error={formik.errors.StateId}
                                        onChange={(e) => { formik.handleChange(e); selectedCityHandler(e.target.value) }}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.StateId && formik.errors.StateId ? true : false}
                                        isMandatory={true} />

                                </Col><Col xl={6}>
                                    <CustomDropdown label={"City"} id={"LocationId"}
                                        value={formik.values.LocationId}
                                        data={filterLocation}
                                        displayField="Name"
                                        valueField={"Id"}
                                        name={"LocationId"}
                                        touched={formik.touched.LocationId}
                                        error={formik.errors.LocationId}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.LocationId && formik.errors.LocationId ? true : false}
                                        isMandatory={true}
                                        disabled={!formik.values.StateId} />

                                </Col>
                            </Row>
                            <Row>
                                <Col xl={12}>
                                    <CustomTextArea
                                        name="Address"
                                        label="Address"
                                        id={"Address"}
                                        value={formik.values.Address}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.Address && formik.errors.Address ? true : false}
                                        error={formik.errors.Address}
                                        onChange={formik.handleChange}
                                        // placeholder={""}
                                        isMandatory={true} />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xl="12" sizeSm="11" md="12" xs="12" lg="12" className="d-flex justify-content-end">
                                    <CustomButton type={'button'} btnClassName={'btn-soft-secondary me-2'} iconClasssName={'bx bx-x font-size-14'} name={undefined} onClick={() => setEditModal(0)} />
                                    <CustomButton type={'submit'} btnClassName={'btn-success'} iconClasssName={''} name={'Save'} disabled={isDisabled} />
                                </Col>
                            </Row>
                        </Card>
                    </Form>
                    <Modal isOpen={isOpenDeleteModal} centered={true} backdrop size={"sm"}>
                        <div className="modal-content p-0">
                            <ModalBody className="px-2 py-5 text-center">
                                <div className="avatar-sm mb-4 mx-auto">
                                    <div className="avatar-title bg-danger text-primary bg-opacity-10 fs-1 rounded-3">
                                        <i className="bx bx-error text-danger"></i>
                                    </div>
                                </div>
                                <p className="text-muted font-size-14 mb-4">Are you sure you want to delete your Profile image?</p>

                                <div className="hstack gap-2 justify-content-center mb-0">
                                    <button type="button" className="btn btn-soft-secondary" onClick={() => { setIsOpenDeleteModal(false) }}>Close</button>
                                    <button type="button" className="btn btn-danger" onClick={() => DeleteProfileImage(userId)}>Delete Now</button>
                                </div>
                            </ModalBody>
                        </div>
                    </Modal>
                </Col>
            </Row>
            <CustomToaster message={resMeg} color={'text-danger'} toast={showToastUpdate} setToast={setShowToastUpdate} />
        </Container >
    );
}



export default INDCreateEdit;
